import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Cookies from "universal-cookie";
import { COMPANY_ID, TOKEN_NAME, COMPANY_EMPLOYEE_ID, PRODUCT_SLUG } from "../../config"; // Add COMPANY_EMPLOYEE_ID constant
import axios from "../../api/axios";
import chatAxios from "../../api/chats";

const cookies = new Cookies();

const useGet = ({
  url,
  initialData,
  params, // Optional: pass params (e.g. read from the URL) to control the query from outside
  onSuccess,
  onError,
  onSettled,
  enabled = true,
  isChat = false, // Add isChat parameter with default false
  returnEntireResponse = false, // Add returnEntireResponse parameter with default false
}) => {
  const [stateParams, setGetListParams] = useState(initialData);
  const paramsObject = params ?? stateParams;
  const company_id = cookies.get(COMPANY_ID);
  const company_employee_id = cookies.get(COMPANY_EMPLOYEE_ID); // Get company_employee_id from cookies

  // Define the function to fetch data
  const getUsers = async (paramsObject) => {
    let token = cookies.get(TOKEN_NAME);
    // console.log("company_id", company_id);

    // Include appropriate IDs based on isChat flag
    const params = {
      ...paramsObject,
      company_id,
      product_slug: PRODUCT_SLUG,
      ...(isChat && { company_employee_id }), // Include company_employee_id only for chat requests
    };

    // Choose the axios instance based on isChat prop
    const axiosInstance = isChat ? chatAxios : axios;

    const response = await axiosInstance.get(`/${url}`, {
      params, // Send as query params
      headers: { Authorization: token ? `Bearer ${token}` : "" },
    });

    if (returnEntireResponse) {
      return response; // Return the entire response if specified
    } else {
      return response.data;
    }
  };

  // Use React Query's useQuery to fetch data
  const list = useQuery([url, paramsObject], () => getUsers(paramsObject), {
    refetchOnWindowFocus: false,
    enabled: enabled,
    retry: 0,
    onSuccess(data) {
      onSuccess?.(data);
    },
    onError(err) {
      onError?.(err);
    },
    onSettled() {
      onSettled?.();
    },
  });

  return { list, paramsObject, setGetListParams };
};

export default useGet;
